import React, { useEffect, useState } from 'react';
import { Box } from '@wix/design-system';
import { BlurControlPS } from './BlurControlPS';
import { AggregatedStyleValues } from '../../common/abstractStyles/types';
import { Host } from '@wix/sdk';
import { loadPanelService } from '../../../automaticPanel/panelsService';
import {
  boxShadowParsedValueToString,
  parseBoxShadowValue,
} from '../../../../apis/services/editActionsServices/nativeActions/globalDesign/shadow/parser';
import { CSS_PROPERTIES } from '@wix/component-protocol/schema';
import { usePartialStyleUpdate } from '../../common/hooks';
import { useBI } from '../../hooks/useBI';
import { ControlService, GlobalDesignStyleGroupMetadata } from '../../types';
import { StylesDerivedNativeActions } from '@wix/editor-platform-host-integration-apis';

type ShadowControlsPSProps = {
  values: AggregatedStyleValues;
  updateStyles: (styles: Record<string, string>) => Promise<void>;
  host: Host;
  metadata: GlobalDesignStyleGroupMetadata;
};

export const ShadowControlsPS: React.FC<ShadowControlsPSProps> = ({
  values,
  updateStyles,
  host,
  metadata,
}) => {
  const [getControl, setGetControl] = useState<
    ControlService['getControl'] | null
  >(null);
  const { trackValueUpdate } = useBI();

  useEffect(() => {
    loadPanelService(host).then((service) => {
      setGetControl(() => service.getControl);
    });
  }, [host]);

  const { getValue, isMixed, getOnChange } = usePartialStyleUpdate({
    values,
    cssPropertyTypes: CSS_PROPERTIES.CSS_PROPERTY_TYPE.boxShadow,
    parse: parseBoxShadowValue,
    serialize: boxShadowParsedValueToString,
    updateStyles,
  });

  const blurValue = getValue('blurRadius') || '';

  const handleBlurChange = (newValue: string) => {
    trackValueUpdate(StylesDerivedNativeActions.shadowStyles, {
      prevValues: blurValue,
      newValues: newValue,
      targetComponents: metadata.targetComponents,
      controlType: 'numeric_input',
      controlId: 'design_box_shadow_blur',
    });
    getOnChange('blurRadius')(newValue);
  };

  if (!getControl || !blurValue) {
    return null;
  }

  return (
    <Box direction="vertical">
      <BlurControlPS
        getControl={getControl}
        value={blurValue}
        onChange={handleBlurChange}
        isMixed={isMixed('blurRadius')}
      />
    </Box>
  );
};
